'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _WebItemTitleInput = require('./components/WebItemTitleInput.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_WebItemTitleInput).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/web-item-title-input/index.js
// module id = 1060
// module chunks = 0